module.exports = __webpack_public_path__ + "static/img/icon_msgjs.1c4003b1.png";